import React from 'react';
import ExternalAppButton from './external_app_button';
import { products } from './app_switcher_config';

export default function ExternalAppSwitcher() {
  return (
    <div className="container px-0 px-md-2" id="external-app-switcher">
      <div className="ml-md-n2 d-flex justify-content-around justify-content-md-start w-100 flex-wrap">
        {products.map(product => (
          <ExternalAppButton key={product.name} product={product} />
        ))}
      </div>
    </div>
  );
}
